export default function SGS() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.59974 15.3509C11.7797 15.3509 15.1682 11.9623 15.1682 7.78236C15.1682 3.6024 11.7797 0.213867 7.59974 0.213867C3.41978 0.213867 0.03125 3.6024 0.03125 7.78236C0.03125 11.9623 3.41978 15.3509 7.59974 15.3509ZM8.23577 3.9978V7.15119H11.3874V8.41267H8.23577V11.5667H6.97429V8.41267H3.81849V7.15119H6.97429V3.9978H8.23577Z"
                fill="white"
            />
        </svg>
    );
}
